var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageLp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3327 41.192C15.6716 41.192 15.1174 40.9727 14.6702 40.5341C14.223 40.0955 13.9993 39.552 13.9993 38.9036V34.3267H44.3327V13.7307H48.9993C49.6605 13.7307 50.2146 13.95 50.6618 14.3886C51.1091 14.8272 51.3327 15.3707 51.3327 16.0191V44.7963C51.3327 45.8261 50.8563 46.5413 49.9035 46.9418C48.9507 47.3422 48.1049 47.1801 47.366 46.4555L41.9993 41.192H16.3327ZM13.9993 29.7498L8.63268 35.0132C7.89379 35.7379 7.04796 35.9 6.09518 35.4995C5.1424 35.0991 4.66602 34.3839 4.66602 33.3541V6.86535C4.66602 6.21696 4.88963 5.67345 5.33685 5.23483C5.78407 4.79621 6.33824 4.5769 6.99935 4.5769H37.3327C37.9938 4.5769 38.548 4.79621 38.9952 5.23483C39.4424 5.67345 39.666 6.21696 39.666 6.86535V27.4614C39.666 28.1098 39.4424 28.6533 38.9952 29.0919C38.548 29.5305 37.9938 29.7498 37.3327 29.7498H13.9993ZM34.9993 25.1729V9.1538H9.33268V25.1729H34.9993Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageLp3);
export default __webpack_public_path__ + "static/media/icon-message-lp3.debdaf9e1a8bd6f9dec041648138b0d4.svg";
export { ForwardRef as ReactComponent };